/** Material Design Icons names shared by Android, PWA, web and desktop. */
export const SPORT_ICON_NAMES: Record<number, string> = {
  1: 'run-fast', 2: 'bike-fast', 3: 'swim', 4: 'wall',
  5: 'weight-lifter', 6: 'flag-checkered', 7: 'sofa-single', 8: 'bike',
  9: 'dumbbell', 10: 'timer-outline', 11: 'ski-cross-country',
  12: 'rowing', 13: 'dots-horizontal', 14: 'walk',
};

export function resolveSportIconName(typeId?: number | null, name?: string | null): string {
  if (typeId != null && SPORT_ICON_NAMES[typeId]) return SPORT_ICON_NAMES[typeId];
  const value = (name ?? '').toLowerCase().replace(/[\s_\u200c-]+/g, '');
  if (/mountain|mtb|کوهستان/.test(value)) return 'bike';
  if (/brick|multisport|triathlon|duathlon|چندگانه|سهگانه|دوگانه/.test(value)) return 'wall';
  if (/crosstrain|crossfit|ترکیبی/.test(value)) return 'weight-lifter';
  if (/strength|weight|gym|قدرت|بدنساز/.test(value)) return 'dumbbell';
  if (/swim|سباحة/.test(value) || value === 'شنا' || value.startsWith('شنای')) return 'swim';
  if (/walk|پیاده|مشي/.test(value)) return 'walk';
  if (/hike|hiking|کوهنورد/.test(value)) return 'hiking';
  if (/row|قایق|تجديف/.test(value)) return 'rowing';
  if (/ski|اسکی/.test(value)) return 'ski-cross-country';
  if (/race|مسابقه/.test(value)) return 'flag-checkered';
  if (/dayoff|rest|استراحت/.test(value)) return 'sofa-single';
  if (/custom|سفارشی/.test(value)) return 'timer-outline';
  if (/run|athletics|track(?:and|&)?field|trail|دویدن|دو(?:و)?(?:و)?میدانی|جري/.test(value)) return 'run-fast';
  if (/bike|cycl|ride|دوچرخ|دراج/.test(value)) return 'bike-fast';
  if (/yoga|pilates|یوگا|پیلاتس/.test(value)) return 'yoga';
  if (/football|soccer|فوتبال/.test(value)) return 'soccer';
  if (/basketball|بسکتبال/.test(value)) return 'basketball';
  if (/tennis|تنیس/.test(value)) return 'tennis';
  return 'dots-horizontal';
}
